import * as React from 'react';
import {Button, Result} from "antd";
import {useTranslation} from "react-i18next";

export function Exception404() {
  const { t } = useTranslation();
	return <Result status="404"
								 title="404"
                 style={{height: '100%'}}
								 subTitle={t('lang459')}/>
}

export function Exception500(props: Record<string, any>) {
  const { t } = useTranslation();
	return <Result  status="500"
									title="500"
                  style={{height: '100%'}}
									subTitle={t('lang432')}
									extra={props.retry ? <Button type="primary" onClick={props.retry}>{t('lang499')}</Button> : null}/>
}

export function Exception403() {
  const { t } = useTranslation();
	return <Result status="403"
								 title={t('lang430')}
                 style={{height: '100%'}}
								 subTitle={t('lang458')}/>;
}
